interface EditIconProps {
  height?: string;
  width?: string;
  strokeColor?: string;
}

const EditIcon = (props: EditIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || "14"}
      height={props.height || "14"}
      viewBox="0 0 14 14"
      fill="none"
    >
      <g clip-path="url(#clip0_6457_99121)">
        <path
          d="M6.41406 2.33119H3.96406C2.98397 2.33119 2.49392 2.33119 2.11958 2.52193C1.7903 2.6897 1.52258 2.95742 1.3548 3.2867C1.16406 3.66105 1.16406 4.1511 1.16406 5.13119V10.0312C1.16406 11.0113 1.16406 11.5013 1.3548 11.8757C1.52258 12.205 1.7903 12.4727 2.11958 12.6404C2.49392 12.8312 2.98397 12.8312 3.96406 12.8312H8.86406C9.84415 12.8312 10.3342 12.8312 10.7085 12.6404C11.0378 12.4727 11.3055 12.205 11.4733 11.8757C11.6641 11.5013 11.6641 11.0113 11.6641 10.0312V7.58119M4.66405 9.33119H5.64086C5.92622 9.33119 6.0689 9.33119 6.20317 9.29895C6.32221 9.27037 6.43601 9.22323 6.54039 9.15927C6.65813 9.08712 6.75902 8.98623 6.9608 8.78445L12.5391 3.20619C13.0223 2.72294 13.0223 1.93944 12.5391 1.45619C12.0558 0.972938 11.2723 0.972938 10.7891 1.45619L5.21078 7.03445C5.009 7.23623 4.90812 7.33712 4.83597 7.45485C4.772 7.55924 4.72486 7.67304 4.69628 7.79208C4.66405 7.92635 4.66405 8.06903 4.66405 8.35439V9.33119Z"
          stroke={props.strokeColor || "#0056D6"}
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6457_99121">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EditIcon;
